/* ============================================================
   Kampagnen-Varianten (CRM / MTA / SGG)
   Tauscht Texte bzw. blendet Blöcke ein/aus, abhängig vom
   Kampagnen-Kürzel in URL oder Discount-Code.

   Erkennung (Priorität):
     1. ?team=CRM                      (explizit, auch zum Testen)
     2. ?discountCode=CRM-…            (Kürzel im Discount-Parameter)
     3. Kürzel irgendwo in der Query   (z. B. utm_campaign=mta_sommer)
     4. discount_code-Cookie           (von /discount/CODE-Links gesetzt)
     5. sessionStorage                 (zuletzt erkanntes Kürzel)

   Mechanik 1 — Text-Swap (z. B. Mepal-Section):
     <p data-campaign-text="description">Standard…</p>
     <template data-campaign-variant="CRM" data-campaign-target="description">CRM-Text…</template>

   Mechanik 2 — Block-Sichtbarkeit (z. B. Image-with-Text):
     <div data-campaign-only="CRM" data-campaign-kind="text" hidden>…</div>
     'none' = Standard-Block, wird ausgeblendet sobald für das aktive
     Kürzel ein Block gleicher Art (data-campaign-kind) existiert.

   Im Theme-Editor (design mode) wird nichts getauscht/versteckt,
   damit alle Blöcke bearbeitbar bleiben.
   ============================================================ */
(function () {
  'use strict';
  if (window.__mmCampaignVariants) return;
  window.__mmCampaignVariants = true;

  var KEYS = ['CRM', 'MTA', 'SGG'];
  var STORE_KEY = 'mm_campaign_variant';

  function matchIn(str) {
    if (!str) return null;
    var up = String(str).toUpperCase();
    for (var i = 0; i < KEYS.length; i++) {
      /* Kürzel nur als eigenständiges Token (nicht Teil eines Wortes) */
      var re = new RegExp('(^|[^A-Z])' + KEYS[i] + '(?=[^A-Z]|$)');
      if (re.test(up)) return KEYS[i];
    }
    return null;
  }

  function persist(v) {
    try { sessionStorage.setItem(STORE_KEY, v); } catch (e) { /* egal */ }
    return v;
  }

  function detect() {
    var search = window.location.search || '';
    var params = null;
    try { params = new URLSearchParams(search); } catch (e) { /* alte Browser */ }

    if (params) {
      var forced = (params.get('team') || '').toUpperCase();
      if (KEYS.indexOf(forced) !== -1) return persist(forced);

      var dc = params.get('discountCode') || params.get('discount') || params.get('discount_code') || '';
      var hitDc = matchIn(dc);
      if (hitDc) return persist(hitDc);
    }

    var hitQuery = matchIn(search);
    if (hitQuery) return persist(hitQuery);

    var cookie = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (cookie) {
      var hitCookie = matchIn(decodeURIComponent(cookie[1]));
      if (hitCookie) return persist(hitCookie);
    }

    try { return sessionStorage.getItem(STORE_KEY); } catch (e) { return null; }
  }

  function apply() {
    /* Im Theme-Editor alles im Originalzustand lassen */
    if (window.Shopify && window.Shopify.designMode) return;

    var v = detect();

    /* ── 1) Text-Swaps ── */
    if (v) {
      var tpls = document.querySelectorAll('template[data-campaign-variant="' + v + '"][data-campaign-target]');
      Array.prototype.forEach.call(tpls, function (tpl) {
        var scope = tpl.closest('.shopify-section') || document;
        var sel = '[data-campaign-text="' + tpl.getAttribute('data-campaign-target') + '"]';
        Array.prototype.forEach.call(scope.querySelectorAll(sel), function (el) {
          el.innerHTML = tpl.innerHTML;
        });
      });
    }

    /* ── 2) Block-Sichtbarkeit ── */
    var flagged = document.querySelectorAll('[data-campaign-only]');
    Array.prototype.forEach.call(flagged, function (el) {
      var mode = el.getAttribute('data-campaign-only'); /* 'none' | 'CRM' | 'MTA' | 'SGG' */
      var scope = el.closest('.shopify-section') || document;
      var kind = el.getAttribute('data-campaign-kind') || '';
      var variantExists = false;
      if (v) {
        var q = '[data-campaign-only="' + v + '"]' + (kind ? '[data-campaign-kind="' + kind + '"]' : '');
        variantExists = !!scope.querySelector(q);
      }
      var show = mode === v || (mode === 'none' && !variantExists);
      el.hidden = !show;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
